import React, { FunctionComponent } from 'react'
import { Grid } from '@material-ui/core'
import { StyledGrid, TextBoleto } from '../styles'
import { colors } from '../../../../../../../shared/styles/colors'
import Radio from '../../../../../../../shared/components/Radio'
import { ETipoPagamentoBoleto } from '../../../../../domain/entities/IPagamentoBoletoResponse'

interface SelecaoTipoPagamentoProp {
  tipoPagamento: ETipoPagamentoBoleto
  setTipoPagamento: (pTipo: ETipoPagamentoBoleto) => void
  onSelectDate?: (dataEscolhida: Date) => void
}
const SelecaoTipoPagamento: FunctionComponent<SelecaoTipoPagamentoProp> = ({
  tipoPagamento,
  setTipoPagamento,
  onSelectDate,
}) => {
  return (
    <>
      <StyledGrid>
        <Grid
          container
          spacing={0}
          style={{
            paddingTop: 18,
            paddingBottom: 12,
          }}
        >
          <Grid item xs={12}>
            <TextBoleto
              $fontSize={'16px'}
              $fontWeight={'400'}
              $color={colors.gray7}
            >
              Quando pagar
            </TextBoleto>
          </Grid>
          <Grid item xs={4}>
            <Radio
              id="pagarHoje"
              label="Hoje"
              name="pagarHoje"
              value="1"
              textColor={colors.gray1}
              indicatorColor={colors.green}
              textWeight={'400'}
              checked={tipoPagamento === 1}
              onChange={() => setTipoPagamento(1)}
            />
            <span style={{ width: 100 }}></span>
          </Grid>
          {/* <Grid item xs={8}> */}
          {/*  <Radio */}
          {/*    id="pagarAgendado" */}
          {/*    label="Agendado" */}
          {/*    name="pagarAgendado" */}
          {/*    value="2" */}
          {/*    textColor={colors.gray1} */}
          {/*    indicatorColor={colors.green} */}
          {/*    textWeight={'400'} */}
          {/*    checked={tipoPagamento === 2} */}
          {/*    onChange={() => setTipoPagamento(2)} */}
          {/*  /> */}
          {/*  <span style={{ width: 100 }}></span> */}
          {/* </Grid> */}
        </Grid>
      </StyledGrid>
    </>
  )
}

export default SelecaoTipoPagamento
